import styles from './StakeholdersInfoDialog.module.css';

import React, { useMemo } from 'react';

import Dialog from 'components/ui/Dialog';
import useTranslation from 'components/hooks/useTranslation';
import BngTable from 'components/bng/ui/BngTable';

export default function StakeholdersInfoDialog({ closeModal = _.noop, stakeholders = [] }) {
  const { t } = useTranslation();

  const tableColumns = useMemo(() => {
    return [
      {
        label: t('name'),
        render: (row) => (
          <div className={styles.stakeholdersData}>
            <span>{row.fullName}</span>
          </div>
        ),
      },
      {
        label: t('email'),
        render: (row) => (
          <div className={styles.stakeholdersData}>
            <span>{row.email}</span>
          </div>
        ),
      },
      {
        label: t('stakeholderRole'),
        render: (row) => (
          <div className={styles.stakeholdersData}>
            <span>{row.type}</span>
          </div>
        ),
      },
    ];
  }, []);

  return (
    <Dialog
      className={`StakeholdersInfoDialog ${styles.StakeholdersInfoDialog}`}
      title={t('stakeholders.dialog')}
      onClose={closeModal}
      newDialogLayout={true}
    >
      <Dialog.Body>
        <BngTable cols={tableColumns} rows={stakeholders} />
      </Dialog.Body>
      <Dialog.Footer />
    </Dialog>
  );
}
